import React from 'react';
import classNames from 'classnames';
import { DataRoomMember } from '../../models/DataRoomMember';
import { useTranslation } from 'react-i18next';
import { Button } from 'ncoded-component-library';
import MailIcon from 'icons/Mail.icon';

import './DataRoomMemberInfo.styles.scss';

type DataRoomMemberInfoProps = {
  className?: string;
  member: DataRoomMember;
  isBuySide: boolean;
  remindColleague?: () => void;
};

const DataRoomMemberInfo: React.FC<DataRoomMemberInfoProps> = (props) => {
  const { className, member, isBuySide, remindColleague } = props;

  const { isAccepted, fullName, email } = member || {};

  const { t } = useTranslation();

  const classes = classNames('data-room-member-info', className);

  return (
    <div className={classes}>
      <p className="name">
        {isAccepted ? fullName : t('invited')}

        <span className="pill">{t(isBuySide ? 'buySide' : 'sellSide')}</span>

        {!isAccepted && remindColleague && (
          <Button variant="link" icon={MailIcon} onClick={remindColleague}>
            {t('remind')}
          </Button>
        )}
      </p>

      {email && <p className="email">{email}</p>}
    </div>
  );
};

export default DataRoomMemberInfo;
